import { Boton, Seccion, Spinner } from 'asocomponents'
import React, { useEffect, useState } from 'react'
import { formatearFechaLuxon } from '../../../../modules/utils/formatearFecha'
import ObservacionService from '../../../../modules/Observacion/application/ObservacionService'
import { WEBURLEGALES } from '../../../helpers/frontend'
import { WindowOpener } from '../../../helpers/window-opener'
import ModalAgregarObservacion from './ModalAgregarObservacion'

export default function ObservacionJuicio({ cargaHabilitada, idJuicio, cuit }) {

    const [isLoading, setIsLoading] = useState(false)
    const [resultado, setResultado] = useState([])
    const [existenRdos, setExistenRdos] = useState(true)
    //PARA EL PAGINADO
    const [paginaActual, setPaginaActual] = useState(1)
    const [elementosPorPagina] = useState(10) // Cambia esto según cuántos elementos quieres mostrar por página
    const [modalOpen, setModalOpen] = useState(false);

    const [message, setMessage] = useState("")

    //#region paginado y fetchData
    const indiceUltimoElemento = paginaActual * elementosPorPagina
    const indicePrimerElemento = indiceUltimoElemento - elementosPorPagina
    let totalPaginas = resultado === null ? 1 : Math.ceil(resultado.length / elementosPorPagina)

    const elementosPaginados =
        resultado === null
            ? []
            : resultado.slice(indicePrimerElemento, indiceUltimoElemento)

    const cambiarPagina = (numeroPagina) => {
        setPaginaActual(numeroPagina)
    }

    const obtenerInstruccionesJuicio = async () => {
        setIsLoading(true)
        const juicioService = new ObservacionService()
        const result = await juicioService.getObservacionesReingenieria(idJuicio,cuit) //226905, 20163545498
        result.observaciones.length > 0 ? setExistenRdos(true) : setExistenRdos(false)

        setPaginaActual(1)
        setResultado(result.observaciones)

        setIsLoading(false)
    }

    const sonResponse = (err, res) => {
        if (err) {
            setMessage(res)
        } else {
            setMessage(res)
        }
    }

    useEffect(() => {
        if (idJuicio && idJuicio !== -1)
            obtenerInstruccionesJuicio()
    }, [idJuicio])


    if (isLoading) {
        return <Spinner color="red" size="50" />
    }

    return (
        <div>
            {cargaHabilitada &&
                <>
                    <Seccion titulo="OBSERVACIONES" />
                    <div className="flex flex-row justify-end items-right mt-2 mr-10 mb-2">
                        <Boton
                            texto="Nueva Observación"
                            icono="add"
                            fondo="rojo"
                            height="h-7" onClick={() => setModalOpen(true)} />
                        <ModalAgregarObservacion
                            isOpen={modalOpen}
                            onClose={() => setModalOpen(false)}
                            idJuicio={idJuicio}
                            onSuccess={() => {
                                setModalOpen(false)
                                obtenerInstruccionesJuicio()
                            }}
                        />
                    </div>
                    <div className="overflow-hidden flex flex-col items-center">
                        <div className="shadow-md sm:rounded-lg w-[95%]">
                            <table className="table-fixed text-xs text-left rtl:text-right text-gray-500 w-full">
                                <thead className="text-[0.6rem] text-gray-700 uppercase bg-gray-200">
                                    <tr>
                                        <th scope="col" className="text-center  py-3" style={{ width: "10%" }}>
                                            Fecha
                                        </th>
                                        <th scope="col" className="text-center  py-3" style={{ width: "60%" }}>
                                            Observación
                                        </th>
                                        <th scope="col" className="text-center  py-3" style={{ width: "30%" }}>
                                            Estado
                                        </th>
                                        <th scope="col" className="text-center  py-1" style={{ width: "7%" }}>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {elementosPaginados &&
                                        elementosPaginados.map((obs, index) => (
                                            <tr
                                                className="bg-white border-b hover:bg-gray-50 text-xs font-normal"
                                                key={obs.observacionId}
                                            >
                                                <td className="text-center py-2">{formatearFechaLuxon(obs.fechaGrabacion, "dd/MM/yyyy")}</td>
                                                <td className="text-left py-2">{obs.observacion}</td>
                                                <td className="text-center py-2">{obs.estado}</td>
                                                <td>
                                                    <WindowOpener url={`${WEBURLEGALES}/GrillaAdjuntoObservacion/${obs.observacionId}`} bridge={sonResponse} width={800} height={300}>
                                                        <Boton
                                                            type="button"
                                                            icono="document"
                                                            alt="Ver Adjuntos Observación"
                                                            width="w-8"
                                                            height="h-6"
                                                        />
                                                    </WindowOpener>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                        {existenRdos && (
                            <div className="w-full flex justify-end items-center mr-12 mt-2">
                                <span className="text-sm m-1">
                                    Página {paginaActual} de {totalPaginas === 0 ? 1 : totalPaginas}
                                </span>
                                <button
                                    className="bg-white hover:bg-gray-200 text-black p-1 rounded border border-gray-400 w-8"
                                    onClick={() => cambiarPagina(paginaActual - 1)}
                                    disabled={paginaActual === 1}
                                >
                                    {"<"}
                                </button>
                                <button
                                    className="bg-white hover:bg-gray-200 text-black p-1 rounded border border-gray-400 w-8"
                                    onClick={() => cambiarPagina(paginaActual + 1)}
                                    disabled={resultado ? indiceUltimoElemento >= resultado.length : true}
                                >
                                    {">"}
                                </button>
                            </div>
                        )}
                    </div>
                </>
            }
        </div>
    )
}